// @flow
import React, { type Node } from 'react';
import { Row } from 'angieslist-react-components';
import ThumbnailImage from './ThumbnailImage';
import type { Image, IndexedImage } from '../../../types';
import './thumbnailImageCarousel.scss';

type Props = {
  images: Image[],
  thumbsPerPage: number,
};

const ThumbnailImageCarouselComponent = ({ images, thumbsPerPage }: Props): Node => {
  const indexedImages = images.map((image, index) => ({ ...image, index }: IndexedImage));
  const imageGroup = indexedImages.slice(0, thumbsPerPage);
  return (
    <Row className="gallery-row" style={{ position: 'relative' }}>
      <div className="clearfix">
        {
          imageGroup.map(image => (
            <ThumbnailImage
              key={image.id}
              image={(image: any)}
              images={indexedImages}
            />
          ))
        }
      </div>
    </Row>
  );
};

export default ThumbnailImageCarouselComponent;



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/reviews/ThumbnailImageCarousel.js